import * as CubiqTS from "../../../../cubiq-model-multi-asset";

export interface IOrderNotifData {
  orderId: string;
  orderRef: string;
  requestedOrderType: CubiqTS.RequestOrderType;
  requestedOrderTypeAsString: string;
  dealtTrackingRate: any;
  orderDate: string;
  instrument: string;
  clientIntent: string;
  clientName: string;
  fixedCode: string;
  dealtTruncatedAmt: string;
  dealtTotalAmt: string;
  hasTrackingSide: boolean;
  deskId: string;
  fullOrderDataObj: CubiqTS.OrderDataImpl;
}

export function isOrderNotifData(object: any): object is IOrderNotifData {
  return "fullOrderDataObj" in object;
}
